import { OPEN_INVITATION_DIALOG, CLOSE_INVITATION_DIALOG } from './action';

const initialState = {
  isOpen: false,
};

const invitationDialog = (state = initialState, action) => {
  switch (action.type) {
    case OPEN_INVITATION_DIALOG:
      return {
        ...state,
        isOpen: true,
      };

    case CLOSE_INVITATION_DIALOG:
      return { ...state, isOpen: false };

    default: {
      return {
        ...state,
      };
    }
  }
};

export default invitationDialog;
